import { Stack } from "@mui/material";
import React from "react";

import { RecurrenceDetailsView } from "./RecurringDetailsView";
import { InstanceDetailsView } from "./InstanceDetailsView";
import { Meeting } from "../../../../model/meeting";

interface MeetingDetailsContainerProps {
  selectedMeeting: Meeting;
}

export const MeetingDetailsContainer: React.FC<
  MeetingDetailsContainerProps
> = ({ selectedMeeting }) => {
  const isTrulyRecurring = selectedMeeting.recurringMeeting != undefined;

  return (
    <Stack
      gap={4}
      sx={{ padding: "20px", width: "100%", height: "100%", overflow: "auto" }}
    >
      {isTrulyRecurring && <RecurrenceDetailsView meeting={selectedMeeting} />}
      <InstanceDetailsView meeting={selectedMeeting} />
    </Stack>
  );
};
